import Cookie from 'js-cookie';
import { Client } from '@/utils';
import { auth } from '@/api';
import _ from 'lodash';

const LOGIN = 'auth/LOGIN';
const REFRESH_TOKEN = 'auth/REFRESH_TOKEN';
const LOAD_CODE = 'auth/LOAD_CODE';
const LOGOUT = 'auth/LOGOUT';
const LOAD_SYSTEMS = 'auth/LOAD_SYSTEMS';
const LOAD_MENULIST = 'auth/LOAD_MENULIST';
const MODIFY_PWD = 'auth/MODIFY_PWD';
const QRLOGIN = 'auth/QRLOGIN';
const QRLOGINSTATUS = "auth/QRSTATUS"
const LOAD_CITYLIST = 'auth/LOAD_CITYLIST';
const UPDATE_CITYNAME = 'auth/UPDATE_CITYNAME';

export default {
  state: {
    token: Cookie.get('token') || '',
    userId: Cookie.get('userId') || '',
    userName: Cookie.get('userName') || '',
    codeUrl: '',
    codeKey: '',
    systems: {
      loaded: false,
      value: [],
    },
    validMenu: {
      loaded: false,
      value: [],
    },
    validMoudle: [],
    validPage: [],
    validBtns: '',
    cityList:[],
    curCityName:'',
  },
  actions: {
    async [QRLOGIN]({ commit }, { data = {}, frontCode = '' ,headers = {}} = {}) {
      const result = await Client.get(auth.getQrCode, {data,headers}, frontCode,false,true,false)
      commit(LOGIN, result);
      return result;
    },

    async [QRLOGINSTATUS]({ commit }, { data = {}, frontCode = '' ,headers = {}} = {}) {
      const result = await Client.post(auth.getQrCodeStatus, {data,headers}, frontCode,false,true,false)
      commit(LOGIN, result);
      return result;
    },

    async [LOGIN]({ commit }, { data = {}, frontCode = '' ,headers = {}} = {}) {
      const result = await Client.post(auth.login, { data,headers }, frontCode,false,true,false);
      commit(LOGIN, result);
      return result;
    },

    async [LOAD_CODE]({ commit }, {data = {},frontCode ='', header= {}} = {}) {
      const result = await Client.post(auth.code, { data: {
          secretkey: 'gnNSqzr6551qyiPB3xoX81z0QhFnjUcE',
          ...data,
        }
      },frontCode,false,true,false)
      commit(LOAD_CODE, result);
      return result;
    },
    async [REFRESH_TOKEN]({ commit }, { data = {}, frontCode = '' } = {}) {
      commit(REFRESH_TOKEN, await Client.post(auth.refreshToken, { data }, frontCode));
    },
    async [LOGOUT]({ commit }, { params = {}, frontCode = '' } = {}) {
      await Client.post(auth.logout, { params }, frontCode);
      commit(LOGOUT);
      commit('root/RESET');
    },
    async [LOAD_MENULIST]({ commit }, { params = {}, frontCode = '',globalLoading = true } = {}) {
      commit(LOAD_MENULIST, await Client.get(`${auth.loadRes}/izk-authservice/menu`, { params }, frontCode,globalLoading));
    },
    async [LOAD_SYSTEMS]({ commit }, { params = {}, frontCode = '' } = {}) {
      commit(LOAD_SYSTEMS, await Client.get(auth.loadSystems, { params }, frontCode));
    },
    async [MODIFY_PWD]({ commit }, { data = {}, frontCode = '' } = {}) {
      await Client.post(auth.modifyPwd, { data }, frontCode);
    },
    async [LOAD_CITYLIST]({ commit }, { params = {}, frontCode = '' } = {}) {
      commit(LOAD_CITYLIST, await Client.get(auth.loadCitylist, { params }, frontCode));
    },
    async [UPDATE_CITYNAME]({ commit }, { data = {}, frontCode = '' } = {}) {
      commit(UPDATE_CITYNAME, data);
    },
  },
  /* eslint-disable no-param-reassign */
  mutations: {
    [LOGIN](state, { token, userName, userId }) {
      state.token = token;
      state.userId = userId;
      state.userName = userName;
    },
    [REFRESH_TOKEN](state) {
      state.token = Cookie.get('token');
    },
    [LOAD_CODE](state, { imgUrl, codeKey }) {
      state.codeUrl = imgUrl;
      state.codeKey = codeKey;
    },
    [LOGOUT]() {},
    [LOAD_MENULIST](state, data) {
      if(data.length >0 ){
        state.validMenu.value = data;
        data.forEach((module) => {
          state.validMoudle.push(module.identifyCode);
          if (module.children && module.children.length > 0) {
            module.children.forEach((page) => {
              state.validPage.push(page.identifyCode);
            });
          }
        });
      }

      function findValidResource(resType, nodes, parentPath) {
        const leafs = [];
        function find(subnodes) {
          subnodes = subnodes || [];
          for (let i = 0; i < subnodes.length; i++) {
            if (subnodes[i].resType === resType) {
              if (!parentPath || parentPath === subnodes[i].resPath) {
                leafs.push(subnodes[i].identifyCode);
              }
            } else if (subnodes[i].children && subnodes[i].children.length > 0) {
              find(subnodes[i].children);
            }
          }
        }
        find(nodes);
        return leafs;
      }
      const validBtns = findValidResource(4, data);
      state.validBtns = validBtns.join(',');

      state.validMenu.loaded = true;
    },
    [LOAD_SYSTEMS](state, data) {
      state.systems.value = data;
      state.systems.loaded = true;
    },
    [LOAD_CITYLIST](state, data) {
      state.cityList = data;
      if(data && data.length != 0){
        if(window.localStorage.getItem('cityCode')){
          let obj = _.find(data, function(o) { return o.cityCode == window.localStorage.getItem('cityCode'); });
          if(!obj){
            window.localStorage.setItem('cityCode', data[0].cityCode);
            state.curCityName = data[0].cityName;
          }else{
            state.curCityName = obj.cityName;
          }
        }else{
          window.localStorage.setItem('cityCode', data[0].cityCode);
          state.curCityName = data[0].cityName;
        }
      }
    },
    [UPDATE_CITYNAME](state, data){
      state.curCityName = data.cityName;
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js